import { createSelector, defaultMemoize } from 'reselect';

import { propertiesSelector } from './properties';
import { subselect } from './root';

const memoizedRating = defaultMemoize(
  (ratingDescriptor, ratingDescriptors) =>
    ratingDescriptors[ratingDescriptor] && ratingDescriptors[ratingDescriptor].displayName,
);

const getRatingDescriptorsByKeySelector = createSelector(
  [propertiesSelector],
  ({ data = {} }) => (ratingDescriptorKey) => memoizedRating(ratingDescriptorKey, data),
);

export const getRatingDescriptorsSelector = subselect(getRatingDescriptorsByKeySelector);
